module.exports = __webpack_public_path__ + "media/images/icon-contact-f0fd0c90f5cd9b17047789e5e5d70cf1.svg";